import { Component, forwardRef, ElementRef, ViewChild, ChangeDetectorRef, Injector } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { SoudotecItemsInputModel } from '../soudotec-items-input.model';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { MatDialog } from '@angular/material/dialog';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { SoudotecItemsInputService } from '../soudotec-items-input.service';
import { SoudotecItemsInputArticlesDialog } from '../items-input-articles-dialog/soudotec-items-input-articles-dialog.component';

@Component({
    selector: 'soudotec-items-input-form',
    providers: [
      {
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SoudotecItemsInputFormComponent),
          multi: true
      },
      {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => SoudotecItemsInputFormComponent),
          multi: true
      }
    ],
    templateUrl: './soudotec-items-input-form.component.html',
    styleUrls: ['./soudotec-items-input-form.component.scss']
})
export class SoudotecItemsInputFormComponent extends AbstractWorkflowFormComponent<SoudotecItemsInputModel, any> {
  itemsScanned: any[] = [];
  component: Model_WorkflowComponent;
  showAlert = false;
  msgAlert = '';
  @ViewChild('itemsContainer') itemsContainer: ElementRef;
  displayedColumns: string[] = ['DESIGNATION', 'QUANTITE', 'ACTION'];
  loading = false;

  constructor(
    private dialog: MatDialog,
    private _inventoryInputService: SoudotecItemsInputService,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.component = this.model.additional as Model_WorkflowComponent;
  }

  doOpenArticlesDialog() {
    const dialogRef = this.dialog.open(SoudotecItemsInputArticlesDialog, {
      data: { },
      width: '100vw',
      panelClass: 'datasource-designer-modal'
    });
    
    dialogRef.afterClosed().subscribe((item?: any) => {
        if (item === undefined) { return; }
        this.addItemToInventory(item);
    });
  }

  addItemToInventory(item: any) {
    if (item.QUANTITE === undefined) { item.QUANTITE = 1; }
    const itemIndex = this.itemsScanned.findIndex(i => i.AR_Ref == item.AR_Ref);
    if (itemIndex != -1) {
      this.itemsScanned[itemIndex].QUANTITE = parseFloat(this.itemsScanned[itemIndex].QUANTITE) + 1;
    } else {
      this.itemsScanned.push(item);
    }
    this._evaluateInventoryValue();

    this.itemsContainer.nativeElement.scrollTop = this.itemsContainer.nativeElement.scrollHeight + 100;
  }

  onMinusQteButtonClicked(_itemIndex: number) {
    this.itemsScanned[_itemIndex].QUANTITE = parseFloat(this.itemsScanned[_itemIndex].QUANTITE) - 1;
    this._evaluateInventoryValue();
  }

  onPlusQteButtonClicked(_itemIndex: number) {
    this.itemsScanned[_itemIndex].QUANTITE = parseFloat(this.itemsScanned[_itemIndex].QUANTITE) + 1;
    this._evaluateInventoryValue();
  }

  onRemoveButtonClicked(_itemIndex: number) {
    this.itemsScanned.splice(_itemIndex, 1);
    this._evaluateInventoryValue();
  }

  private _evaluateInventoryValue() {
    const articles: any[] = this.itemsScanned.map(ligne => ({ 
      AR_CodeBarre: ligne.AR_CodeBarre, 
      AR_Ref: ligne.AR_Ref, 
      AR_Design: ligne.AR_Design, 
      FA_CodeFamille: ligne.FA_CodeFamille, 
      QUANTITE: ligne.QUANTITE
    }));
    this.onValueChanged(articles);
  }

  onQteTyped(_event, rowIndex: number) {
    this.itemsScanned[rowIndex].QUANTITE = _event.detail.value;
    this._evaluateInventoryValue();
  }

  async onScanned(_scannedCode: string) {
    if (!_scannedCode) { return; }
    if (this.itemsScanned == null) { this.itemsScanned = []; }

    this.showAlert = false;
    this.msgAlert = '';
    const dbItem = this.itemsScanned.find(a => a.AR_CodeBarre == _scannedCode);
    if (!!dbItem) {
      this.addItemToInventory(dbItem);
    } else {
      this.loading = true;
      try {
        const articles = await this._inventoryInputService.doFindArticlesAction({ ScannedCode: _scannedCode });
        if (articles.length == 0) {
          throw new Error(`Aucun article ne correspond au code-barres scanné : ${_scannedCode}`);
        }
        const article = articles[0];
        this.addItemToInventory(article);
        this.loading = false;
      } catch(e) {
        this.msgAlert = `Aucun article ne correspond au code-barres scanné : ${_scannedCode}`;
        this.loading = false;
        this.showAlert = true;
      }
    }
    this._cdf.detectChanges();
  }
}